import React from "react";
import useApiLoading from "./hooks/useApiLoading";
import { ThemeProvider } from "./theme/ThemeProvider";

/**
 * Application adapter for the portable theme.
 *
 * App-level API state is injected once here. Generic theme components consume
 * it through ThemeProvider without importing application hooks directly.
 */
const AppThemeProvider = ({ children }) => {
  const apiLoading = useApiLoading();

  return (
    <ThemeProvider loadingState={apiLoading}>
      {children}
    </ThemeProvider>
  );
};

export default AppThemeProvider;
